import React from "react";
import './taFormField.css';
import {TaFormFieldCaption} from "./taFormFieldCaption";
import {TaFormFieldLabel} from "./taFormFieldLabel";

export const TaFormField = (props) => {

  const {
    label,
    description,
    disabled,
    isRequired,
    className,
    meta,
    htmlFor,
  } = props;

  const baseClass = 'ta-form-field';
  const {invalid, touched, error} = (meta) ? meta : {};
  const hasError = (touched && invalid) ? 'error' : null;

  let classNames = [baseClass];
  if (invalid) {
    classNames.push(baseClass + '--invalid');
  }
  if (touched) {
    classNames.push(baseClass + '--touched');
  }
  if (hasError) {
    classNames.push(baseClass + '--error');
  }
  if (disabled) {
    classNames.push(baseClass + '--disabled');
  }
  if (className) {
    classNames.push(className);
  }

  return (
    <div className={classNames.join(' ')}>
      {label && (
          <TaFormFieldLabel isRequired={isRequired} htmlFor={htmlFor}>{label}</TaFormFieldLabel>
      )}
      <div className="ta-form-field__input">{props.children}</div>
      {description && (
          <TaFormFieldCaption>{description}</TaFormFieldCaption>
      )}
      {/*{description && (*/}
      {/*    <TaFormFieldError>{description}</TaFormFieldError>*/}
      {/*)}*/}
    </div>
  );
};